import { render, staticRenderFns } from "./biaodan.vue?vue&type=template&id=7a2da37a"
import script from "./biaodan.vue?vue&type=script&lang=js"
export * from "./biaodan.vue?vue&type=script&lang=js"
import style0 from "./biaodan.vue?vue&type=style&index=0&id=7a2da37a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports